<template>
    <div class="row justify-content-center">
        <div class="col-md-5">
            <h3 class="text-center">Update Product</h3>
            <form @submit.prevent="onUpdateForm">
                <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="product.name" required>
                </div>

                <div class="form-group">
                    <label>Description</label>
                    <textarea  class="form-control" v-model="product.description" required></textarea>
                </div>

                <div class="form-group">
                    <label>Price</label>
                    <input type="number" class="form-control" v-model="product.price" required>
                </div>
                <div class="form-group">
                    <label>Rating</label>
                    <input type="text" class="form-control" v-model="product.rating" required>
                </div>
                <div class="form-group mt-2">
                    <button class="btn btn-primary btn-block">Update Product</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { db } from '../firebase';

    export default {
        data() {
            return {
                product: {
                }
            }
        },
        created() {
            let dbRef = db.collection('AllProducts').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.product = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        },
        methods: {
            onUpdateForm(event) {
                event.preventDefault()
                //convert string to number
                this.product.price = parseInt(this.product.price);
                db.collection('AllProducts').doc(this.$route.params.id)
                .update(this.product).then(() => {
                    console.log("Product successfully updated!");
                    this.$router.push('/')
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>